module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "overlay d-flex flex-column align-items-center justify-content-center",
    class: _vm.promptClass
  }, [_c('div', {
    staticClass: "promptHolder py-3 px-5 radius-normal darker"
  }, [_c(_vm.selectedTemplate, {
    tag: "div",
    attrs: {
      "info": _vm.getRichPromptServerInfo
    },
    on: {
      "clickedOk": _vm.clickedOk,
      "clickedCancel": _vm.clickedCancel
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b086c78"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/richPrompt/richPrompt.vue
// module id = 2128
// module chunks = 0